import { Envs } from '../../envs'

export const USER_GROUPS_REDIRECT_URL = `${Envs.APP_URL}/user_groups`
